import React, { useEffect, useState } from 'react';
import Partner from './Partner';
import './Partner.css';
import { getPartnerCompaniesFromLinyuan } from '../../common/javascripts/common';

export default function Partners() {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    async function load() {
      try {
        const page = await getPartnerCompaniesFromLinyuan(1, 100);
        const list = page.list || [];
        const ordered = list
          .slice()
          .filter((item) => item.isPartner === 1)
          .sort((a, b) => Number(a.id) - Number(b.id));
        setPartners(ordered);
      } catch (e) {
        console.error('Error fetching partner companies from linyuanApi', e);
        setPartners([]);
      }
    }
    load();
  }, []);

  return (
    <div className="partners_container">
      <div className="sec_title">
        <span>合作伙伴</span>
        <span>PARTNERSHIPS</span>
      </div>
      <div className="partners_item_box">
        {partners.map((item) => {
          const key = item.id;
          const title = item.nameCn || item.alias || item.nameEn || '';
          const logo = item.logoUrl || '';
          if (!logo) {
            return null;
          }
          return <Partner key={key} title={title} src={logo} />;
        })}
      </div>
    </div>
  );
}
